import { MeetingRoom } from '../types/models';
import { supabase } from './supabase';

/**
 * 모든 회의실 정보 가져오기
 */
export const getRooms = async (): Promise<MeetingRoom[]> => {
  const { data, error } = await supabase
    .from('rooms')
    .select('*')
    .order('id', { ascending: true }); 

  if (error) {
    console.error('Error fetching rooms:', error);
    throw error;
  }

  console.log('회의실 정보 가져오기 성공:', data);
  return data || [];
};
